
import { Calendar, momentLocalizer } from 'react-big-calendar';
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from 'moment';
import 'moment/locale/sq';
import { useEffect, useState } from 'react';
import YearModel from '../../components/Model/YearModel';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { DashboardGetDetailAction } from '../../redux/Action/DashboardAction';
import { capitalizeFirstLetter, encodeID, sidebarOpen } from '../../utils/Helper';
import Spinner from '../../components/Spinner';
import { Link, useNavigate } from 'react-router-dom';
import { Config } from '../../config/Config';
import { Routes } from '../../constants/RouteConstants';
import {
    salonOwnerNeedsSubscription,
    salonOwnerSubscriptionExpired,
    salonOwnerSubscriptionFeatureLocked,
    salonOwnerSubscriptionSuspended,
} from '../../utils/subscriptionAccess';

const Dashboard = () => {
    const dispatch = useDispatch<any>();
    const intl = useIntl();
    const dashboard_detail = useSelector((state: any) => state.DashboardDetailGetState);
    const profileData = useSelector((state: any) => state.GetProfileState);
    const user = profileData?.data?.data || Config?.USER_DETAILS;
    const needsSub = salonOwnerNeedsSubscription(user);
    const suspended = salonOwnerSubscriptionSuspended(user);
    const subExpired = salonOwnerSubscriptionExpired(user);
    const featureLocked = salonOwnerSubscriptionFeatureLocked(user);
    const expiredTooltip = intl.formatMessage({
        id: 'subscription_expired_feature_tooltip',
        defaultMessage:
            'Your subscription has expired. Renew your plan to access this feature.',
    });
    const suspendedOfflineTooltip = intl.formatMessage({
        id: 'subscription_suspended_offline_booking_tooltip',
        defaultMessage:
            'Offline booking is unavailable while your subscription is suspended.',
    });

    const local_language = localStorage.getItem("lang")
    moment.locale(local_language == "alb" ? "sq" : "en");
    const localizer = momentLocalizer(moment);
    const [currentDate, setCurrentDate]: any = useState(new Date());

    const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const currentYear = currentDate.getFullYear();


    //  ************************ For Year selection ************************
    const [currentYearSelected, setCurrentYearSelected] = useState(currentYear)

    const handlePrev = () => {
        const newDate = new Date(currentDate);
        newDate.setMonth(newDate.getMonth() - 1);
        setCurrentDate(newDate);
    };


    const handleNext = () => {
        const newDate = new Date(currentDate);
        newDate.setMonth(newDate.getMonth() + 1);
        setCurrentDate(newDate);
    };



    const events = dashboard_detail?.data?.data.map((detail: any) => {
        return {
            title: "#" + detail?.service_id + " " + capitalizeFirstLetter(detail?.service_details?.name),
            start: detail?.booking_date ? moment(detail.booking_date).toDate() : null,
            end: detail?.booking_date ? moment(detail.booking_date).toDate() : null,
        };
    }).filter((event: any) => event.start !== null && event.end !== null);




    useEffect(() => {
        dispatch(DashboardGetDetailAction({ month: currentMonth, year: String(currentYear) }))
    }, [currentMonth, currentYear]);


    useEffect(() => {
        const newDate = new Date(currentYearSelected, currentDate.getMonth(), currentDate.getDate());
        setCurrentDate(newDate);
    }, [currentYearSelected]);


    const navigate = useNavigate()
    const handleClickEvent = (e: any) => {

        navigate(`/my-bookings/${encodeID(e?.start)}/${encodeID(currentMonth)}`)

    }

    const eventStyleGetter = (event: any) => {
        const style: React.CSSProperties = {
            background: "#E44D3A",
            color: 'white',
            borderRadius: '5px',
            border: 'none',
            width: 'calc(100% - 30px)',
            marginBottom: '10px',
            fontSize: '12px',
            margin: '0 auto 1px',
            position: 'relative',
        };
        return {
            style,
        };
    };



    return (
        <>
            <div className='col-lg-9'>
                {dashboard_detail?.loading ? <Spinner /> : ""}
                <div className='dashboard'>
                    <div className='dashboardTop d-sm-flex align-items-center justify-content-between'>
                        <h2><button type='button' className='btn mobileMenu p-1 d-lg-none' onClick={() => { sidebarOpen() }}><span className="icon-menu-right"></span></button>
                            <FormattedMessage id="dashboard" />
                        </h2>
                        {!needsSub && !featureLocked && (
                            <Link to="/offline-booking" className='btn btnOUtlinePrimary'><FormattedMessage id="create_booking_offline" /></Link>
                        )}
                        {!needsSub && featureLocked && (
                            <span title={suspended ? suspendedOfflineTooltip : expiredTooltip}>
                                <button type="button" className='btn btnOUtlinePrimary' disabled style={{ pointerEvents: 'auto' }}>
                                    <FormattedMessage id="create_booking_offline" />
                                </button>
                            </span>
                        )}
                    </div>
                    {subExpired && (
                        <div className="alert alert-info mb-3 dashboard-subscription-banner" role="alert">
                            <p className="small mb-0 flex-grow-1 pe-sm-2">
                                <FormattedMessage
                                    id="subscription_expired_banner"
                                    defaultMessage="Your subscription has expired. You can still use your account, but services management, staff management, and offline bookings are unavailable until you renew."
                                />
                            </p>
                            <Link to={Routes.SubscriptionPlans} className="btn btn-fill btn-sm text-nowrap">
                                <FormattedMessage id="subscription_plans_title" defaultMessage="Subscription plans" />
                            </Link>
                        </div>
                    )}
                    {suspended && (
                        <div className="alert alert-danger mb-3 dashboard-subscription-banner" role="alert">
                            <div className="flex-grow-1 pe-sm-2">
                                <strong className="d-block mb-1">
                                    <FormattedMessage id="subscription_suspended_title" defaultMessage="Your salon account is suspended" />
                                </strong>
                                <p className="small mb-0">
                                    <FormattedMessage
                                        id="subscription_suspended_body_dashboard"
                                        defaultMessage="An administrator suspended your subscription. You can still use your account, but services management, staff management, and offline bookings are unavailable until access is restored. Open Subscription for details."
                                    />
                                </p>
                            </div>
                            <Link to={Routes.SubscriptionPlans} className="btn btn-fill btn-sm text-nowrap">
                                <FormattedMessage id="subscription_plans_title" defaultMessage="Subscription plans" />
                            </Link>
                        </div>
                    )}
                    {needsSub && (
                        <div className="alert alert-warning mb-3 dashboard-subscription-banner" role="alert">
                            <div className="flex-grow-1 pe-sm-2">
                                <strong className="d-block mb-1">
                                    <FormattedMessage id="subscription_required_title" defaultMessage="Subscription required" />
                                </strong>
                                <p className="small mb-0">
                                    <FormattedMessage
                                        id="subscription_required_body"
                                        defaultMessage="Purchase a subscription to access services, staff, bookings, and other salon features."
                                    />
                                </p>
                            </div>
                            <Link to={Routes.SubscriptionPlans} className="btn btn-fill btn-sm text-nowrap">
                                <FormattedMessage id="subscription_plans_title" defaultMessage="Subscription plans" />
                            </Link>
                        </div>
                    )}
                    <div className='DashboardCalendar'>
                        <Calendar
                            localizer={localizer}
                            startAccessor="start"
                            endAccessor="end"
                            views={['month']}
                            date={currentDate}
                            onNavigate={setCurrentDate}
                            eventPropGetter={eventStyleGetter}
                            events={events}
                            onSelectEvent={handleClickEvent}
                            dayLayoutAlgorithm="no-overlap"
                            components={{
                                toolbar: props => (
                                    <>
                                        <div className='calendarToolbar'>
                                            <button type='button' className='btn' onClick={handlePrev}><span className="icon-angel-left"></span></button>
                                            <h6 data-bs-toggle="modal" data-bs-target="#yearModel">{moment(currentDate).format('MMMM YYYY')}</h6>
                                            <button type='button' className='btn' onClick={handleNext}><span className="icon-angel-right"></span></button>
                                        </div>

                                        <YearModel setCurrentYearSelected={setCurrentYearSelected} currentYearSelected={currentYearSelected} />
                                    </>

                                ),
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Dashboard;
